export default "__VITE_ASSET__DYy_Sw2Z__"